var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeCardCashback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1645_1938)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#DFE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.125 32.8664C41.3951 33.5639 41.8 34.2014 42.3165 34.7424C42.833 35.2835 43.451 35.7175 44.1353 36.0197C44.8195 36.3219 45.5566 36.4864 46.3044 36.5037C47.0522 36.5211 47.7961 36.391 48.4936 36.1208C49.1912 35.8507 49.8286 35.4458 50.3697 34.9293C50.9107 34.4128 51.3448 33.7947 51.647 33.1105C51.9492 32.4263 52.1136 31.6892 52.131 30.9414C52.1483 30.1936 52.0182 29.4497 51.7481 28.7522C51.4779 28.0546 51.0731 27.4171 50.5565 26.8761C50.04 26.335 49.422 25.901 48.7378 25.5988C48.0535 25.2966 47.3165 25.1322 46.5687 25.1148C45.8208 25.0974 45.0769 25.2276 44.3794 25.4977C43.6819 25.7678 43.0444 26.1727 42.5034 26.6892C41.9623 27.2058 41.5283 27.8238 41.2261 28.508C40.9239 29.1923 40.7594 29.9293 40.7421 30.6771C40.7247 31.4249 40.8548 32.1688 41.125 32.8664Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4033 28.3988C47.2246 28.2548 47.01 28.162 46.7826 28.1305C46.5552 28.0991 46.3236 28.13 46.1124 28.2201L44.9321 28.6772C44.619 28.7984 44.367 29.0391 44.2313 29.3462C44.0957 29.6532 44.0876 30.0016 44.2089 30.3147C44.3301 30.6277 44.5707 30.8798 44.8778 31.0154C45.1849 31.151 45.5333 31.1591 45.8463 31.0379L47.0267 30.5808C47.3397 30.4595 47.6881 30.4676 47.9952 30.6032C48.3023 30.7389 48.5429 30.9909 48.6642 31.304C48.7854 31.617 48.7773 31.9654 48.6417 32.2725C48.5061 32.5796 48.254 32.8202 47.941 32.9414L46.7606 33.3986C46.5495 33.4886 46.3178 33.5196 46.0904 33.4881C45.863 33.4566 45.6485 33.3639 45.4697 33.2198",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2937 27.8585L47.5794 33.7602",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33.116,
    width: 54.0411,
    height: 38.32,
    rx: 5,
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7972 65.3795C62.6072 65.2104 62.3206 65.2109 62.1312 65.3805C54.6983 72.0385 44.0899 77.5932 32.6484 74.4031C29.9351 73.6331 27.2809 72.3378 24.8772 70.6573C24.6502 70.4885 24.6818 70.3313 24.699 70.2941C24.7099 70.2704 24.7244 70.2589 24.7427 70.2528C24.7604 70.2469 24.8249 70.2324 24.9502 70.2868C28.2479 71.8142 30.9984 71.7878 34.2366 71.7371C39.5491 71.6734 44.1851 69.5393 48.0061 66.7126C50.8577 64.6123 53.3338 62.0936 55.523 59.3615C55.6922 59.1503 55.6627 58.8427 55.4563 58.6676L51.9468 55.6889L67.3417 53.6745L67.1288 69.234L62.7972 65.3795Z",
    fill: "#F2F8FF",
    stroke: "#00193C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.041 22.75C56.041 23.6364 56.2156 24.5142 56.5548 25.3331C56.894 26.1521 57.3912 26.8962 58.018 27.523C58.6448 28.1498 59.389 28.647 60.2079 28.9862C61.0269 29.3254 61.9046 29.5 62.791 29.5C63.6774 29.5 64.5552 29.3254 65.3741 28.9862C66.1931 28.647 66.9372 28.1498 67.564 27.523C68.1908 26.8962 68.688 26.1521 69.0272 25.3331C69.3664 24.5142 69.541 23.6364 69.541 22.75C69.541 21.8636 69.3664 20.9858 69.0272 20.1669C68.688 19.3479 68.1908 18.6038 67.564 17.977C66.9372 17.3502 66.1931 16.853 65.3741 16.5138C64.5552 16.1746 63.6774 16 62.791 16C61.9046 16 61.0269 16.1746 60.2079 16.5138C59.389 16.853 58.6448 17.3502 58.018 17.977C57.3912 18.6038 56.894 19.3479 56.5548 20.1669C56.2156 20.9858 56.041 21.8636 56.041 22.75Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.891 20.5C64.7552 20.2643 64.5578 20.07 64.32 19.9379C64.0822 19.8058 63.8129 19.7408 63.541 19.75H62.041C61.6432 19.75 61.2617 19.908 60.9804 20.1893C60.6991 20.4706 60.541 20.8522 60.541 21.25C60.541 21.6478 60.6991 22.0294 60.9804 22.3107C61.2617 22.592 61.6432 22.75 62.041 22.75H63.541C63.9388 22.75 64.3204 22.908 64.6017 23.1893C64.883 23.4706 65.041 23.8522 65.041 24.25C65.041 24.6478 64.883 25.0294 64.6017 25.3107C64.3204 25.592 63.9388 25.75 63.541 25.75H62.041C61.7691 25.7591 61.4999 25.6942 61.2621 25.5621C61.0243 25.43 60.8269 25.2357 60.691 25",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.791 19.0001V26.5001",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 43.5,
    width: 53,
    height: 6,
    fill: "#0E5CF4",
    stroke: "#00193C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1645_1938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeCardCashback);
export default __webpack_public_path__ + "static/media/ic-large-card-cashback.9fb43dc7f761a295ed115d1c6db11113.svg";
export { ForwardRef as ReactComponent };